import { CommonModule } from '@angular/common';
import { CardContent } from '@/shared/components/card-content/card-content';
import { ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { DetalhamentoPendencias } from '../detalhamento-pendencias/detalhamento-pendencias';
import { IndicadorPendencia } from './indicador-pendencia.model';
import { PendenciaLinha } from './pendencia-linha.model';
import { MedicoPendenciaFeatureService } from './medico-pendencia.service';
import { MedicoPendenciaResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-pendencia.model';
import { MedicoRneVencendoResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-rne-vencendo.model';
import { MessageService } from 'primeng/api';
import { DateUtils } from '@/shared/utils/date-utils';
import { SelectEstado } from '@/shared/components/layout/select-estado/select-estado';
import { MapaUfCard } from '@/shared/components/mapa-uf-card/mapa-uf-card';
import { PainelLateral } from '@/shared/components/painel-lateral/painel-lateral';
import { TagModule } from 'primeng/tag';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { type PaginatorState } from 'primeng/paginator';
import { AuthService } from '@/core/auth/auth.service';
import { UfSelecaoGestaoService } from '../uf-selecao-gestao.service';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-mapa-pendencias',
    standalone: true,
    imports: [DialogoPadraoDirective, CommonModule, FormsModule, DetalhamentoPendencias, TagModule, SelectEstado, MapaUfCard, CardModule, SkeletonModule, ButtonModule, DialogModule, CardContent, PainelLateral],
    templateUrl: './mapa-pendencias.html',
    styleUrl: './mapa-pendencias.scss'
})
export class MapaPendencias implements OnInit {
    indicadores: IndicadorPendencia[] = [
        {
            id: 'historico-divergente',
            titulo: 'Divergências no histórico',
            descricao: 'Médicos com divergências no histórico.',
            grupo: 'Registro profissional',
            classeGrupo: 'grupo-registro',
            quantidade: null,
            icone: 'pi pi-history'
        },
        {
            id: 'cpf-invalido',
            titulo: 'CPF ausente ou inválido',
            descricao: 'Médicos sem CPF ou com CPF inválido.',
            grupo: 'Dados pessoais',
            classeGrupo: 'grupo-dados',
            quantidade: null,
            icone: 'pi pi-id-card'
        },
        {
            id: 'genero-ausente',
            titulo: 'Gênero não informado',
            descricao: 'Médicos sem informações de gênero.',
            grupo: 'Dados pessoais',
            classeGrupo: 'grupo-dados',
            quantidade: null,
            icone: 'pi pi-users'
        },
        {
            id: 'nascimento-divergente',
            titulo: 'Nascimento ausente ou divergente',
            descricao: 'Médicos sem data de nascimento ou com divergências na data de nascimento.',
            grupo: 'Dados pessoais',
            classeGrupo: 'grupo-dados',
            quantidade: null,
            icone: 'pi pi-calendar'
        },
        {
            id: 'especialidade-registro-incompleto',
            titulo: 'Registro de especialidades incompleto',
            descricao: 'Médicos sem número, folha ou livro do registro de especialidades.',
            grupo: 'Registro profissional',
            classeGrupo: 'grupo-registro',
            quantidade: null,
            icone: 'pi pi-briefcase'
        },
        {
            id: 'formatura-inconsistente',
            titulo: 'Formação inconsistente',
            descricao: 'Médicos com data de formatura anterior à criação da faculdade ou formados antes dos 18 anos.',
            grupo: 'Formação',
            classeGrupo: 'grupo-formacao',
            quantidade: null,
            icone: 'pi pi-graduation-cap'
        },
        {
            id: 'formatura-pos-inscricao',
            titulo: 'Formatura após inscrição',
            descricao: 'Médicos com data de formatura superior à data de inscrição.',
            grupo: 'Formação',
            classeGrupo: 'grupo-formacao',
            quantidade: null,
            icone: 'pi pi-verified'
        },
        {
            id: 'endereco-invalido',
            titulo: 'Endereço de correspondência inválido',
            descricao: 'Médicos sem endereço de correspondência ou com endereço inválido.',
            grupo: 'Endereço',
            classeGrupo: 'grupo-endereco',
            quantidade: null,
            icone: 'pi pi-map-marker'
        },
        {
            id: 'diploma-prazo-vencido',
            titulo: 'Prazo de diploma vencido',
            descricao: 'Médicos com prazo vencido para apresentação de diploma.',
            grupo: 'Diplomas',
            classeGrupo: 'grupo-diplomas',
            quantidade: null,
            icone: 'pi pi-clock'
        },
        {
            id: 'cancelamento-com-debito',
            titulo: 'Cancelamento com débitos',
            descricao: 'Médicos que tiveram o registro cancelado mesmo havendo débitos.',
            grupo: 'Financeiro',
            classeGrupo: 'grupo-financeiro',
            quantidade: null,
            icone: 'pi pi-credit-card'
        },
        {
            id: 'idade-mais-80',
            titulo: 'Inscritos com mais de 80 anos',
            descricao: 'Médicos inscritos com mais de 80 anos.',
            grupo: 'Idade',
            classeGrupo: 'grupo-idade',
            quantidade: null,
            icone: 'pi pi-user'
        },
        {
            id: 'rne-vencendo',
            titulo: 'RNE provisória vencendo',
            descricao: 'RNE de registro provisório vencendo em 30 dias.',
            grupo: 'RNE',
            classeGrupo: 'grupo-rne',
            quantidade: null,
            icone: 'pi pi-exclamation-triangle'
        },
        {
            id: 'rne-vencido',
            titulo: 'RNE provisória vencida',
            descricao: 'RNE de registro provisório já vencido.',
            grupo: 'RNE',
            classeGrupo: 'grupo-rne',
            quantidade: null,
            icone: 'pi pi-times-circle'
        }
    ];

    indicadorSelecionado: IndicadorPendencia | null = null;
    indicadorMaximizado: IndicadorPendencia | null = null;
    exibirModalMaximizado = false;
    linhasPendencias: PendenciaLinha[] = [];
    totalRegistros = 0;
    first = 0;
    rows = 100;
    carregandoPendencias = false;
    ufSelecionada: string | null = null;
    ufsPermitidas: string[] | null = null;
    private ufTokenRestrita: string | null = null;
    private ufConsulta: string | null = null;
    private readonly ufChange$ = new Subject<void>();
    private readonly detalheChange$ = new Subject<void>();

    constructor(
        private pendenciaService: MedicoPendenciaFeatureService,
        private messageService: MessageService,
        private destroyRef: DestroyRef,
        private authService: AuthService,
        private ufSelecaoGestao: UfSelecaoGestaoService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.configurarUfPorToken();
        this.onUfSelecionadaChange(this.ufSelecionada);
    }

    onUfSelecionadaChange(uf?: string | null): void {
        this.ufChange$.next();
        this.ufSelecionada = this.normalizarUfSelecionada(uf);
        this.ufSelecaoGestao.definir(this.ufSelecionada);

        this.ufConsulta = this.ufSelecionada;
        this.indicadorSelecionado = null;
        this.indicadorMaximizado = null;
        this.exibirModalMaximizado = false;
        this.resetarIndicadores();
        this.linhasPendencias = [];
        this.totalRegistros = 0;
        this.first = 0;
        this.carregandoPendencias = false;

        this.carregarTotais();
    }

    private configurarUfPorToken(): void {
        const ufToken = this.authService.ufDoUsuario()?.trim().toUpperCase() ?? '';
        const ufTokenValida = /^[A-Z]{2}$/.test(ufToken) ? ufToken : '';

        if (ufTokenValida && ufTokenValida !== 'BR') {
            this.ufTokenRestrita = ufTokenValida;
            this.ufsPermitidas = [ufTokenValida];
            this.ufSelecionada = ufTokenValida;
            this.ufSelecaoGestao.definir(ufTokenValida);
            return;
        }

        this.ufTokenRestrita = null;
        this.ufsPermitidas = null;
        this.ufSelecionada = this.ufSelecaoGestao.uf();
    }

    private normalizarUfSelecionada(uf?: string | null): string | null {
        const ufNormalizada = String(uf ?? '')
            .trim()
            .toUpperCase();

        if (!ufNormalizada || ufNormalizada === 'BR') {
            return this.ufTokenRestrita;
        }

        if (!/^[A-Z]{2}$/.test(ufNormalizada)) {
            return this.ufTokenRestrita;
        }

        if (this.ufTokenRestrita && ufNormalizada !== this.ufTokenRestrita) {
            return this.ufTokenRestrita;
        }

        return ufNormalizada;
    }

    selecionarIndicador(indicador: IndicadorPendencia): void {
        this.detalheChange$.next();
        this.exibirModalMaximizado = false;
        this.indicadorMaximizado = null;
        this.indicadorSelecionado = indicador;
        this.first = 0;
        this.linhasPendencias = [];
        this.totalRegistros = 0;
        this.carregarPendenciasIndicador(indicador.id);
    }

    maximizarIndicador(indicador: IndicadorPendencia): void {
        this.indicadorMaximizado = indicador;
        this.exibirModalMaximizado = true;
    }

    voltarParaMapa(): void {
        this.detalheChange$.next();
        this.indicadorSelecionado = null;
        this.linhasPendencias = [];
        this.totalRegistros = 0;
        this.first = 0;
        this.carregandoPendencias = false;
    }

    onPageChange(event: PaginatorState): void {
        this.detalheChange$.next();
        this.first = event.first ?? 0;
        this.rows = event.rows ?? this.rows;
        if (this.indicadorSelecionado) {
            this.carregarPendenciasIndicador(this.indicadorSelecionado.id);
        }
    }

    private carregarPendenciasIndicador(indicadorId: string): void {
        if (indicadorId === 'historico-divergente') {
            this.carregarPendenciasHistorico();
        } else if (indicadorId === 'cpf-invalido') {
            this.carregarPendenciasCpfInvalidos();
        } else if (indicadorId === 'genero-ausente') {
            this.carregarPendenciasGeneroNaoInformado();
        } else if (indicadorId === 'nascimento-divergente') {
            this.carregarPendenciasNascimentoDivergente();
        } else if (indicadorId === 'especialidade-registro-incompleto') {
            this.carregarPendenciasEspecialidade();
        } else if (indicadorId === 'formatura-inconsistente') {
            this.carregarPendenciasFormaturaInconsistente();
        } else if (indicadorId === 'formatura-pos-inscricao') {
            this.carregarPendenciasFormaturaPosInscricao();
        } else if (indicadorId === 'endereco-invalido') {
            this.carregarPendenciasEnderecoCorrespondencia();
        } else if (indicadorId === 'diploma-prazo-vencido') {
            this.carregarPendenciasPrazoDiplomaVencido();
        } else if (indicadorId === 'cancelamento-com-debito') {
            this.carregarPendenciasCancelamentoComDebito();
        } else if (indicadorId === 'idade-mais-80') {
            this.carregarPendenciasInscritosAcima80Anos();
        } else if (indicadorId === 'rne-vencendo') {
            this.carregarPendenciasRneVencendo();
        } else if (indicadorId === 'rne-vencido') {
            this.carregarPendenciasRneVencido();
        } else {
            this.linhasPendencias = [];
            this.totalRegistros = 0;
        }
    }

    private obterPaginacao(): { page: number; size: number } {
        const size = this.rows;
        const page = size > 0 ? Math.floor(this.first / size) : 0;
        return { page, size };
    }

    private carregarTotais(): void {
        this.carregarTotalHistorico();
        this.carregarTotalCpfInvalidos();
        this.carregarTotalGeneroNaoInformado();
        this.carregarTotalNascimentoDivergente();
        this.carregarTotalEspecialidade();
        this.carregarTotalFormaturaInconsistente();
        this.carregarTotalFormaturaPosInscricao();
        this.carregarTotalEnderecoCorrespondencia();
        this.carregarTotalPrazoDiplomaVencido();
        this.carregarTotalCancelamentoComDebito();
        this.carregarTotalInscritosAcima80Anos();
        this.carregarTotalRneVencendo();
        this.carregarTotalRneVencido();
    }

    private carregarTotalHistorico(): void {
        this.pendenciaService
            .totalPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                // markForCheck: os totais chegam em callback assíncrono e são gravados em campos
                // não-signal; sob o layout OnPush o tick da resposta não alcançaria este painel
                // (renderizava só após um clique). Marcar o caminho como "dirty" resolve.
                next: (total) => {
                    this.atualizarQuantidadeIndicador('historico-divergente', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('historico-divergente', null);
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao obter o total de pendencias do historico.' });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalCpfInvalidos(): void {
        this.pendenciaService
            .totalCpfInvalidosOuNulosPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('cpf-invalido', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('cpf-invalido', null);
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao obter o total de pendencias de CPF invalido.' });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalGeneroNaoInformado(): void {
        this.pendenciaService
            .totalGeneroNaoInformadoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('genero-ausente', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('genero-ausente', null);
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao obter o total de pendencias de genero nao informado.' });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalNascimentoDivergente(): void {
        this.pendenciaService
            .totalDivergenciaDataNascimentoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('nascimento-divergente', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('nascimento-divergente', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de nascimento divergente.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalEspecialidade(): void {
        this.pendenciaService
            .totalEspecialidadePorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('especialidade-registro-incompleto', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('especialidade-registro-incompleto', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de especialidade.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalFormaturaInconsistente(): void {
        this.pendenciaService
            .totalFormaturaAntesCriacaoFaculdadePorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('formatura-inconsistente', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('formatura-inconsistente', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de formatura inconsistente.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalFormaturaPosInscricao(): void {
        this.pendenciaService
            .totalFormaturaMaiorQueInscricaoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('formatura-pos-inscricao', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('formatura-pos-inscricao', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de formatura apos inscricao.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalEnderecoCorrespondencia(): void {
        this.pendenciaService
            .totalEnderecoCorrespondenciaPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('endereco-invalido', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('endereco-invalido', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de endereco de correspondencia.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalPrazoDiplomaVencido(): void {
        this.pendenciaService
            .totalPrazoDiplomaVencidoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('diploma-prazo-vencido', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('diploma-prazo-vencido', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de prazo de diploma vencido.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalCancelamentoComDebito(): void {
        this.pendenciaService
            .totalCancelamentoComDebitoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('cancelamento-com-debito', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('cancelamento-com-debito', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de cancelamento com debito.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalInscritosAcima80Anos(): void {
        this.pendenciaService
            .totalInscritosAcima80AnosPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('idade-mais-80', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('idade-mais-80', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de pendencias de inscritos acima de 80 anos.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalRneVencendo(): void {
        this.pendenciaService
            .totalRneVencendoEm30DiasPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('rne-vencendo', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('rne-vencendo', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de RNE vencendo em 30 dias.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarTotalRneVencido(): void {
        this.pendenciaService
            .totalRneVencidoPorUf(this.ufConsulta)
            .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.ufChange$))
            .subscribe({
                next: (total) => {
                    this.atualizarQuantidadeIndicador('rne-vencido', total ?? 0);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.atualizarQuantidadeIndicador('rne-vencido', null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao obter o total de RNE vencido.'
                    });
                    this.cdr.markForCheck();
                }
            });
    }

    private carregarPendenciasHistorico(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar pendencias do historico.' });
                }
            });
    }

    private carregarPendenciasCpfInvalidos(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarCpfInvalidosOuNulosPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar pendencias de CPF invalido.' });
                }
            });
    }

    private carregarPendenciasGeneroNaoInformado(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarGeneroNaoInformadoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar pendencias de genero nao informado.' });
                }
            });
    }

    private carregarPendenciasNascimentoDivergente(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarDivergenciaDataNascimentoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de nascimento divergente.'
                    });
                }
            });
    }

    private carregarPendenciasEspecialidade(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarEspecialidadePorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de especialidade.'
                    });
                }
            });
    }

    private carregarPendenciasFormaturaInconsistente(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarFormaturaAntesCriacaoFaculdadePorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de formatura inconsistente.'
                    });
                }
            });
    }

    private carregarPendenciasFormaturaPosInscricao(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarFormaturaMaiorQueInscricaoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de formatura apos inscricao.'
                    });
                }
            });
    }

    private carregarPendenciasEnderecoCorrespondencia(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarEnderecoCorrespondenciaPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de endereco de correspondencia.'
                    });
                }
            });
    }

    private carregarPendenciasPrazoDiplomaVencido(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarPrazoDiplomaVencidoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de prazo de diploma vencido.'
                    });
                }
            });
    }

    private carregarPendenciasCancelamentoComDebito(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarCancelamentoComDebitoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de cancelamento com debito.'
                    });
                }
            });
    }

    private carregarPendenciasInscritosAcima80Anos(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarInscritosAcima80AnosPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaPendencia(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar pendencias de inscritos acima de 80 anos.'
                    });
                }
            });
    }

    private carregarPendenciasRneVencendo(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarRneVencendoEm30DiasPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaRne(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar RNE vencendo em 30 dias.'
                    });
                }
            });
    }

    private carregarPendenciasRneVencido(): void {
        const { page, size } = this.obterPaginacao();
        this.carregandoPendencias = true;
        this.pendenciaService
            .listarRneVencidoPorUf(this.ufConsulta, page, size)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                takeUntil(this.ufChange$),
                takeUntil(this.detalheChange$),
                finalize(() => {
                    this.carregandoPendencias = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (resp) => {
                    this.linhasPendencias = (resp?.content ?? []).map((item) => this.mapLinhaRne(item));
                    this.totalRegistros = resp?.totalElements ?? 0;
                },
                error: () => {
                    this.linhasPendencias = [];
                    this.totalRegistros = 0;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao carregar RNE vencido.'
                    });
                }
            });
    }

    private atualizarQuantidadeIndicador(indicadorId: string, total: number | null): void {
        const indicador = this.indicadores.find((item) => item.id === indicadorId);
        if (indicador) {
            indicador.quantidade = total;
        }
    }

    private resetarIndicadores(): void {
        this.indicadores.forEach((item) => {
            item.quantidade = null;
        });
    }

    private mapLinhaPendencia(item: MedicoPendenciaResponse): PendenciaLinha {
        return {
            uf: item.ufSgUf ?? '',
            crm: item.nuCrm ?? '',
            nome: item.nmSolicitante ?? '',
            situacao: item.dsSituacao ?? item.inSituacao ?? '',
            codigoSituacao: item.inSituacao ?? '',
            detalhe: item.informacaoComplementar ?? ''
        };
    }

    private mapLinhaRne(item: MedicoRneVencendoResponse): PendenciaLinha {
        return {
            crm: item.nuCrm ?? '',
            nome: item.nmSolicitante ?? '',
            vencimento: DateUtils.formatDate(item.dtFim ?? '')
        };
    }
}
